"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencyFieldLogic = void 0;
const types_1 = require("@smartsuite/types");
const clipboard_1 = require("../../utils/clipboard");
const google_sheet_1 = require("../../utils/google-sheet");
const currency_1 = require("../../formatters/currency");
const detailed_decimal_1 = require("../../formatters/detailed-decimal");
const intl_1 = require("../../locale/intl");
const currency_fieldtype_1 = require("../../safe-field-value/numder-fields/currency-field/currency.fieldtype");
const texts_1 = require("../../texts");
const number_1 = require("../../utils/number");
const base_number_fieldtype_1 = require("../base-fields/base-number.fieldtype");
class CurrencyFieldLogic extends base_number_fieldtype_1.BaseNumberFieldLogic {
    constructor(conf) {
        super(conf);
        this.name = "currencyfield";
        this.label = (0, intl_1.$t)(texts_1.currencyFieldText.currency);
        this.icon = "currency";
        this.iconColor = "#FF5757";
        this.placeholder = (0, intl_1.$t)(texts_1.currencyFieldText.enter_number_here);
        this.searchSynonyms = [(0, intl_1.$t)(texts_1.currencyFieldText.money), "$"];
        this.isNumber = true;
        this.fieldValueGetter = new currency_fieldtype_1.CurrencyFieldValueGetter();
        // @ts-expect-error: Need to resolve
        this.clipboardPasteRules = {
            numberfield: clipboard_1.clipboardNumberToNumber,
            currencyfield: clipboard_1.clipboardNumberToNumber,
            percentfield: clipboard_1.clipboardNumberToNumber,
            ratingfield: clipboard_1.clipboardNumberToNumber,
            autonumberfield: clipboard_1.clipboardNumberToNumber,
            rollupfield: clipboard_1.clipboardTextToNumber,
            votefield: clipboard_1.clipboardTextToNumber,
            countfield: clipboard_1.clipboardCountToNumber,
            numbersliderfield: clipboard_1.clipboardNumberToNumber,
            percentcompletefield: clipboard_1.clipboardNumberToNumber,
            unknownfield: clipboard_1.clipboardTextToNumber,
            textfield: clipboard_1.clipboardTextToNumber,
            recordtitlefield: clipboard_1.clipboardTextToNumber,
            richtextareafield: clipboard_1.clipboardTextToNumber,
            textareafield: clipboard_1.clipboardTextToNumber,
        };
        this.currencies = conf.currencies;
    }
    valueToString(fieldValue, field, userPreferences) {
        return (0, currency_1.convertCurrencyFieldValueToString)({
            value: fieldValue,
            locale: userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.locale,
            currencies: this.currencies,
            params: field.params,
        });
    }
    valueToExport(fieldValue, field, userPreferences) {
        var _a, _b;
        return (0, detailed_decimal_1.convertNumberToFormatedString)({
            value: fieldValue !== null && fieldValue !== void 0 ? fieldValue : "",
            precision: (_a = field.params.precision) !== null && _a !== void 0 ? _a : 0,
            decimalSeparator: (0, number_1.getDecimalSeparator)((_b = userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.locale) === null || _b === void 0 ? void 0 : _b.value),
            thousandSeparator: "",
        });
    }
    valueToGoogleSheet(fieldValue, _field, _userPreferences) {
        if (fieldValue === null) {
            return (0, google_sheet_1.makeRowDataValues)(null, "numberValue");
        }
        if (!fieldValue) {
            return (0, google_sheet_1.makeRowDataValues)(0, "numberValue");
        }
        if (isNaN(Number(fieldValue))) {
            const parsedValue = fieldValue.replace(",", ".");
            return (0, google_sheet_1.makeRowDataValues)(Number(parsedValue) || 0, "numberValue");
        }
        return (0, google_sheet_1.makeRowDataValues)(Number(fieldValue), "numberValue");
    }
    valueToExcelExport(fieldValue, field, userPreferences) {
        return {
            t: fieldValue ? "n" : "t",
            v: fieldValue !== null && fieldValue !== void 0 ? fieldValue : "",
        };
    }
    getInitialFieldValue(startValue, field, userPreferences) {
        return this.validateValue(field, startValue, true, userPreferences)
            ? startValue
            : this.getEmptyValue();
    }
    getGridColumnSettings(field) {
        return {
            ...super.getGridColumnSettings(field),
            contentAlignment: "right",
        };
    }
    getLinkedRecordFieldSmartWidth(_field) {
        return {
            defaultWidht: 90,
            minWidth: 45,
        };
    }
    /**
     * Checks if the values are equal.
     */
    isValueEqual(fieldValue1, fieldValue2, _field, _userPreferences) {
        return fieldValue1 === fieldValue2;
    }
    prepareValueForClipboard(fieldValue, srcField, userPreferences) {
        return {
            text: (0, currency_1.convertCurrencyFieldValueToString)({
                value: fieldValue,
                locale: userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.locale,
                currencies: this.currencies,
                params: {
                    ...srcField.params,
                    precision: srcField.params.number_abbreviation
                        ? srcField.params.precision
                        : (0, number_1.getDecimalPlacesNum)(String(fieldValue)),
                },
            }),
            rawValue: fieldValue,
        };
    }
    filterToRecordValue(filterValue, comparison, field) {
        if (comparison !== "is_equal_to" || !(0, number_1.isNumeric)(filterValue)) {
            throw new types_1.FilterToRecordValueConversionError(field, filterValue, comparison);
        }
        const value = Number(filterValue);
        if (!field.params.allow_negative && value < 0) {
            throw new types_1.FilterToRecordValueConversionError(field, filterValue, comparison);
        }
        return value;
    }
    metricWidgetValueToString(fieldValue, field, userPreferences) {
        const numberValue = String(fieldValue);
        return this.valueToString(numberValue, field, userPreferences);
    }
}
exports.CurrencyFieldLogic = CurrencyFieldLogic;
